import { ProgressBar, type ProgressBarProps } from '@ets/design-system';

import styles from './styles.module.scss';

type ProgressBarGroupProps = Omit<ProgressBarProps, 'children' | 'progress'> &
  Required<Pick<ProgressBarProps, 'progress'>> & {
    steps: number;
    activeStep: number;
  };

export const ProgressBarGroup = ({
  steps,
  activeStep,
  width,
  progress,
  ...props
}: ProgressBarGroupProps) => {
  const getProgress = (barStep: number, activeStep: number, progress: number) => {
    if (barStep < activeStep) {
      return 100;
    }
    if (barStep === activeStep) {
      return progress;
    }
    return 0;
  };

  return (
    <div className={styles.container} style={{ width }}>
      {Array.from({ length: steps }).map((_, index) => (
        <ProgressBar
          key={index}
          {...props}
          progress={getProgress(index + 1, activeStep, progress)}
        />
      ))}
    </div>
  );
};
